import { a as get } from "./utils2.mjs";

//#region src/api/workflowHistory.ts
const getWorkflowHistory = async (context, workflowId, queryParams) => {
	const { data } = await get(context.baseUrl, `/workflow-history/workflow/${workflowId}`, queryParams);
	return data;
};
const getWorkflowVersion = async (context, workflowId, versionId) => {
	const { data } = await get(context.baseUrl, `/workflow-history/workflow/${workflowId}/version/${versionId}`);
	return data;
};

//#endregion
export { getWorkflowVersion as n, getWorkflowHistory as t };
//# sourceMappingURL=workflowHistory.mjs.map